const regexFormatArgument = /{\d+}/g

export const stringFormatter = {
    cutIfHaveMoreThan: (value: string | null, length: number): string => {
        if (!value) return ''

        if (value.length > length) return `${value.substring(0, length)}...`

        return value
    },

    getTextObligatoryField: (field: string): string => {
        return `El campo ${field} es obligatorio`
    },

    toCNPJ: (value: string | null | undefined): string => {
        if (!value) return ''

        return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
    },

    format: (base: string, lstArguments: string[]): string => {
        let finalString: string = base

        let matchArr: RegExpExecArray | null
        while ((matchArr = regexFormatArgument.exec(finalString)) !== null) {
            const indexArg = Number(matchArr[0].substring(1, matchArr[0].length - 1))

            if (lstArguments[indexArg]) finalString = finalString.replace(matchArr[0], lstArguments[indexArg])
        }

        return finalString
    }
}
